import './paywall.css';
import { IonIcon } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';
import { ReactElement, ReactNode } from 'react';
import { PaywallModalWrapper } from './paywall-modal-wrapper';
import { PaywallComponentBaseProps } from './paywall.types';

interface CustomActionProps {
  presentUpgrade: () => void;
}

export interface PaywallBlurProps extends PaywallComponentBaseProps {
  blurId?: string;
  children?: ReactNode;
  disableBlur?: boolean;
  customAction?: (props: CustomActionProps) => ReactElement;
  disableClick?: boolean;
}

const PaywallBlur = (props: PaywallBlurProps) => {
  const {
    blurId,
    planEntitlementKey,
    children,
    disableBlur,
    customAction,
    disableClick,
    isFeatureAvailable,
  } = props;

  return (
    <PaywallModalWrapper planEntitlementKey={planEntitlementKey}>
      {({ presentUpgrade, hasEntitlement }) => {
        const isAvailable = isFeatureAvailable
          ? isFeatureAvailable(hasEntitlement)
          : hasEntitlement;
        return (
          <div className="paywall-blur-container">
            {children}
            <div id={blurId} className="paywall-blur-background">
              {!isAvailable && !disableBlur && (
                <div
                  className="paywall-blur-effect"
                  onClick={disableClick ? undefined : presentUpgrade}
                >
                  <div className="paywall-blur-lock">
                    {!customAction && (
                      <IonIcon icon={lockClosed} size="large" />
                    )}
                    {customAction && customAction({ presentUpgrade })}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      }}
    </PaywallModalWrapper>
  );
};

export { PaywallBlur };
